import Sortable from 'sortablejs/modular/sortable.core.esm.js';

export default function sortable(node, opts = {}) {
    const s = new Sortable(node,  {
        onEnd: (evt) => {
            node.dispatchEvent(new CustomEvent("sortEnd", {detail: evt}));
        },
        ...opts
    })


    return {
        destroy() {
            s.destroy();
        }
    }
}

export function getBeforeAfter(list, oldIndex, newIndex) {
    let after, before;

    if (newIndex == 0) {
        before = list[newIndex + 1];
    } else if (newIndex == list.length - 1) {
        after = list[newIndex]
    } else {
        if (newIndex < oldIndex) {
            after = list[newIndex - 1];
            before = list[newIndex];
        } else {
            after = list[newIndex];
            before = list[newIndex + 1]
        }
    }

    return {before, after};
}